import React from "react";
import {FileTextOutlined, UpOutlined, DownOutlined} from "@ant-design/icons";
import {GroupBox, GroupHeader, GroupContent} from "../styles/SubCompanyInvoice.styles";

export const InvoiceGroupBox = ({variant, title, count, expanded, onToggle, children}) => (
    <GroupBox $variant={variant}>
        <GroupHeader $variant={variant} $expanded={expanded} onClick={onToggle}>
            <FileTextOutlined className="group-icon" />
            <span className="group-title">{title}</span>
            <span className="group-count">{count} fatura</span>
            {expanded ? <UpOutlined /> : <DownOutlined />}
        </GroupHeader>
        {expanded && <GroupContent>{children}</GroupContent>}
    </GroupBox>
);
